import Lenis from 'lenis';

let lenisInstance = null;

export const getLenis = () => lenisInstance;

export const lenis = () => {
    lenisInstance = new Lenis({
        duration: 1.3,
        smooth: true,
        prevent: node =>
            node.classList?.contains('overflow-y-auto') ||
            node.classList?.contains('overflow-auto') ||
            node.classList?.contains('hero-movie') ||
            node.classList?.contains('listing__filters-sidebar-body') ||
            node.classList?.contains('minicart-sidebar__body'),
    });

    function raf(time) {
        lenisInstance.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
};
